<template>
  <div class="service">
    <div class="service-list">
      <div
        class="service-item"
        v-for="item in config"
        :key="item.title"
        :style="{ backgroundImage: `url(${item.cover})` }"
        @click="handleClick(item)"
      >
        <div class="item-wrap">
          <div
            class="item-img"
            :style="{ backgroundImage: `url(${item.icon})` }"
          ></div>
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc" v-html="item.desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from './config';
export default {
  name: 'Service',
  data: () => {
    return {
      config,
    };
  },
  methods: {
    handleClick(val) {
      this.$router.push(val.path);
    },
  },
};
</script>
<style lang="less" scoped>
.service {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  background-color: #fff;

  .service-list {
    display: flex;
    justify-content: center;
    .service-item {
      width: 300px;
      height: 340px;
      background-size: 100% 100%;
      background-repeat: no-repeat;

      &:nth-of-type(2n) {
        // opacity: 0.3;
      }

      &:hover {
        transition: background-size 0.3s ease;
        background-size: 110% 110%;
        background-position: center;
        cursor: pointer;
      }

      &:nth-child(2),
      &:nth-child(4) {
        .item-wrap {
          background-color: rgba(0, 0, 0, 0.4);
        }
      }

      &:nth-child(3) {
        .item-wrap {
          background-color: rgba(0, 0, 0, 0.7);
        }
      }

      .item-wrap {
        width: 100%;
        height: 340px;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: background-color 0.3s ease;

        &:hover {
          background-color: rgba(23, 84, 252, 0.7);
        }
        .item-img {
          margin-top: 90px;
          margin-bottom: 20px;
          width: 46px;
          height: 46px;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .item-title {
          font-size: 20px;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          margin-bottom: 10px;
        }

        .item-desc {
          text-align: center;
          font-size: 16px;
          font-weight: 300;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>
